import React from 'react';
import { Skeleton } from '@mui/material';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { StyledSentences } from './index.style';

const Sentences = ({ sentences, loadingSentences }) => {
  const { t } = useTranslation();

  return (
    <StyledSentences>
      {loadingSentences ? (
        <div>
          {[...Array(4)].map(() => (
            <Skeleton
              animation="wave"
              height={30}
              width="650px"
              className="skeleton"
            />
          ))}
        </div>
      ) : (
        <>
          <div style={{ textAlign: 'center' }}>
            <Typography
              component="p"
              textTransform="uppercase"
              color={COLOR.descriptionUpload}
              variant="body-14-medium"
              style={{
                display: 'flex',
                alignItems: 'center',
                height: '40px',
                justifyContent: 'center',
              }}
            >
              {t('readTheSentence')}
            </Typography>
          </div>
          <div style={{ marginTop: '16px' }}>
            <Typography
              component="p"
              variant="body-20-medium"
              color={COLOR.darkGray}
              gutterBottom
            >
              {sentences?.originalText}
            </Typography>
          </div>
        </>
      )}
    </StyledSentences>
  );
};

export default Sentences;
